const autoNgTemplateLoaderTemplate1 = require('./application.html');

angular.module('shbdeployer.kubernetes').component('kubernetesApplicationView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesApplicationController',
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
    endpoint: '<',
  },
});
